import {
  SET_INITIAL_DATA,
  OPEN_MOBILE_MENU,
  CLOSE_MOBILE_MENU,
  NAVIGATE_FROM_MOBILE_MENU,
  SELECT_MOBILE_MENU_HISTORY,
  CHANGE_MOBILE_MENU_CATEGORIES,
} from '../actions/mobile-menu';

export default (state, action) => {
  if (!state) {
    return {
      open: false,
      history: [],
    };
  }

  switch (action.type) {
    case OPEN_MOBILE_MENU: {
      return {
        ...state,
        open: true,
      };
    }
    case CLOSE_MOBILE_MENU: {
      return {
        ...state,
        open: false,
      };
    }
    case NAVIGATE_FROM_MOBILE_MENU: {
      return {
        ...state,
        navigatedFromMobileMenu: true,
      };
    }
    case 'ROUTE_LOADED': {
      return {
        ...state,
        navigatedFromMobileMenu: false,
        // Reset mobile menu history, essentially going back to the top level of the mobile menu,
        // unless we just navigated from mobile menu, e.g. clicked a category link in it.
        history: state.navigatedFromMobileMenu
          ? state.history
          : state.history.slice(0, 1),
      };
    }
    case SET_INITIAL_DATA: {
      const { categories } = action;
      return {
        ...state,
        categories,
        history: [
          {
            id: 'root',
            name: null,
            semantic_id: null,
            children: categories,
          },
        ],
      };
    }
    case CHANGE_MOBILE_MENU_CATEGORIES: {
      const { categories, parent } = action;

      return {
        ...state,
        categories,
        history: [...state.history, parent],
        // Keep track of whether we're traversing up or down the category tree
        // to determine transition direction
        isTraversingUpwards: false,
      };
    }
    case SELECT_MOBILE_MENU_HISTORY: {
      const { categoryId } = action;
      const index = state.history.findIndex(
        current => current.id === categoryId
      );

      if (index >= 0) {
        return {
          ...state,
          history: state.history.slice(0, index + 1),
          categories: state.history[index].children,
          // Keep track of whether we're traversing up or down the category tree
          // to determine transition direction
          isTraversingUpwards: true,
        };
      }

      return {
        ...state,
      };
    }
    default:
  }

  return state;
};
